import { BalancesLabels } from '../i18n/balances-labels';
import { BalancesService } from '../services/balances.services';
export class BalancesExportUtil {

    // Single grid
    public static getExpandColumnList() {
        let columnList = [];
        columnList.push(BalancesExportUtil.getAccountGridList());
        columnList.push(BalancesExportUtil.getColumnList());
        columnList.push( [{ "displayName": "Cash Management Balance(Detail)", "column": "cashmgmtname", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "", "column": "cashmgmtvalue", "cssClass": "left-align", "columnWidth": 130, "fixed": true }]);
        return columnList;
    }
    public static getColumnList() {

        let columnList = [];
        columnList.push({ "displayName": "Key Values", "column": "name", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Current Value", "column": "value", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Change", "column": "difference", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Change (%)", "column": "percentChange", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }
    public static getCashColumnList() {

        let columnList = [];
        columnList.push({ "displayName": "Cash Management Balance(Detail)", "column": "cashmgmtname", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "", "column": "cashmgmtvalue", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }
    public static getAccountGridList() {

        let columnList = [];
        columnList.push({ "displayName": "", "column": "accountnum", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "", "column": "accountid", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "", "column": "currencycode", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }
    // Currency grid
    public static getCurrencyColumnsList() {

        let columnList = [];
        columnList.push(BalancesExportUtil.getAccountGridList());
        columnList.push(BalancesExportUtil.getColumnList());
        columnList.push(BalancesExportUtil.getCashColumnList());
        columnList.push([{ "displayName": "Balance Type", "column": "acctType", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Currency (Native)", "column": "localCcy", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Cash Balance", "column": "currTradeDateBalance", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Market Value", "column": "currMktValAmt", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Equity", "column": "currEquityAmt", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Equity (%)", "column": "currEquityPct", "cssClass": "left-align", "columnWidth": 130, "fixed": true }]);
        return columnList;
    }
    // multiple grids
    public static getColumnsList() {

        let columnList = [];
        columnList.push(BalancesExportUtil.getAccountGridList());
        columnList.push(BalancesExportUtil.getColumnList());
        columnList.push(BalancesExportUtil.getCashColumnList());
        columnList.push([{ "displayName": "Balance Type", "column": "acctType", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Currency (Native)", "column": "localCcy", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Cash Balance", "column": "currTradeDateBalance", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Market Value", "column": "currMktValAmt", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Equity", "column": "currEquityAmt", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "Equity (%)", "column": "currEquityPct", "cssClass": "left-align", "columnWidth": 130, "fixed": true }]);
        columnList.push(BalancesExportUtil.getMortgageandLoansColumnList());
        columnList.push(BalancesExportUtil.ColumnListsThird());
        columnList.push(BalancesExportUtil.getLoansColumnList());
        return columnList;
    }
    public static ColumnListsThird() {
        let columnList = [];
        columnList.push({ "displayName": "MORTGAGE ACCOUNT NUMBER", "column": "clientAcctNumber", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "LOAN TYPE", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "BANKING INSTITUTION", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "AMOUNT OUTSTANDING", "column": "currentBalance", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "MORTGAGE TYPE", "column": "contactInformation", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "ORIGINAL LOAN AMOUNT", "column": "originalLoanAmount", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "LOAN ORIGINATION DATE", "column": "originationDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "NEXT ADJUSTMENT DATE", "column": "nextAdjustmentDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "NEXT PAYMENT AMOUNT", "column": "nextPaymentAmount", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "NEXT PAYMENT DUE DATE", "column": "paymentDueDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "INTEREST RATE", "column": "interestRate", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "MATURITY DATE", "column": "maturityDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "CONTACT INFORMATION", "column": "contactInformation", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "PROPERTY & MORTGAGE INFO", "column": "name", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }

    //loan and mortgage grid 
    public static getMortgageColumnList() {
        let columnList = [];
        columnList.push(BalancesExportUtil.getAccountGridList());
        columnList.push(BalancesExportUtil.getColumnList());
        columnList.push(BalancesExportUtil.getCashColumnList());
        columnList.push(BalancesExportUtil.getMortgageandLoansColumnList());
        columnList.push([{ "displayName": "MORTGAGE ACCOUNT NUMBER", "column": "clientAcctNumber", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "LOAN TYPE", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "BANKING INSTITUTION", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "AMOUNT OUTSTANDING", "column": "currentBalance", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "MORTGAGE TYPE", "column": "acctType", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "ORIGINAL LOAN AMOUNT", "column": "originalLoanAmount", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "LOAN ORIGINATION DATE", "column": "originationDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "NEXT ADJUSTMENT DATE", "column": "nextAdjustmentDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "NEXT PAYMENT AMOUNT", "column": "nextPaymentAmount", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "NEXT PAYMENT DUE DATE", "column": "paymentDueDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "INTEREST RATE", "column": "interestRate", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "MATURITY DATE", "column": "maturityDateStr", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "CONTACT INFORMATION", "column": "contactInformation", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "PROPERTY & MORTGAGE INFO", "column": "name", "cssClass": "left-align", "columnWidth": 130, "fixed": true }]);
        columnList.push(BalancesExportUtil.getLoansColumnList());
        return columnList;
    }
    public static getLoansColumnList() {
        let columnList = [];
        columnList.push({ "displayName": "CREDIT FACILITY NUMBER", "column": "clientFacility", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "LOAN TYPE", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "BANKING INSTITUTION", "column": "dataSourceName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "CREDIT LINE LIMIT", "column": "creditLineLimit", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "AVAILABLE CREDIT", "column": "availableCredit", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "AMOUNT OUTSTANDING", "column": "currentBalance", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "INTEREST PAID YTD", "column": "interestPaidYtd", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "INTEREST PAID LAST YEAR", "column": "interestPaidLastYear", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "CONTACT INFORMATION", "column": "contactInformation", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }
// mortgages and loans 
public static getMortgageandLoansColumnList() {
    let columnList = [];
    columnList.push(
        { "displayName": "LOAN TYPE", "column": "loantype", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "CREDIT LINE LIMIT", "column": "creditLimit", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "AVAILABLE CREDIT", "column": "availableCredit", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
        { "displayName": "AMOUNT OUTSTANDING", "column": "outstdamount", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
    return columnList;
}
    public static getTaxReClaimColList() {
        let columnList = [];
        columnList.push({"displayName": "Payable Date", "column": "payableDate", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Account", "column": "account", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Currency", "column": "currencyCode", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Security Name", "column": "securityName", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
            { "displayName": "Balance Due", "column": "balanceDueAmount", "cssClass": "left-align", "columnWidth": 130, "fixed": true,},
            { "displayName": "Status", "column": "statusCode", "cssClass": "left-align", "columnWidth": 130, "fixed": true });
        return columnList;
    }

    public static processBalancesDetails(bd: any, bdc: any, bs:any, bsc: any, type: string, deviceType: string, balancesService: BalancesService){
        let balanceDetail = [];
        balanceDetail.push({
            name: BalancesLabels.DETAIL_KEYVALUES_LONGMARKET,
            value: bd !== null ? bd.longMarketValue.value: bdc.longMarketValue.value,
            difference: bd !== null ? bd.longMarketValue.difference : bdc.longMarketValue.difference,
            percentChange: bd !== null ? bd.longMarketValue.percentChange : bdc.longMarketValue.percentChange,
            valuec: bdc !== null ? bdc.longMarketValue.value : bd.longMarketValue.value,
            differencec: bdc !== null ? bdc.longMarketValue.difference : bd.longMarketValue.difference,
            percentChangec: bdc !== null ? bdc.longMarketValue.percentChange: bd.longMarketValue.percentChange,
            heirarchy: [BalancesLabels.DETAIL_KEYVALUES_LONGMARKET],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_LONGMARKET,
            displayAllValues: true,
            legend: balancesService.updateDisclaimer({
                'legendSymbol': '', legendByIndex: true, 'key': BalancesLabels.DISCLAIMER_LONGMARKETVALUE,
                'show': true, 'className': 'longMarketValue', 'showCounter': 0
            }),
            class: 'longMarketValue'
        });
        if (type !== 'custodian'){
            balanceDetail.push({
                name: BalancesLabels.DETAIL_KEYVALUES_SHORTMARKET,
                value: bd !== null ? bd.shortMarketValue.value : bdc.shortMarketValue.value,
                difference: bd !== null ? bd.shortMarketValue.difference : bdc.shortMarketValue.difference,
                percentChange: bd !== null ? bd.shortMarketValue.percentChange : bdc.shortMarketValue.percentChange,
                valuec: bdc !== null ? bdc.shortMarketValue.value : bd.shortMarketValue.value,
                differencec: bdc !== null ? bdc.shortMarketValue.difference : bd.shortMarketValue.difference,
                percentChangec: bdc !== null ? bdc.shortMarketValue.percentChange : bd.shortMarketValue.percentChange,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_SHORTMARKET],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_SHORTMARKET,
                displayAllValues: true,
                class: 'shortMarketValue'
            });
        }
        if ((bd !== null && bd.securitiesOwed.value && bd.securitiesOwed.value !== 0) || (bdc !== null && bdc.securitiesOwed.value && bdc.securitiesOwed.value !== 0)) {
            balanceDetail.push({
                name: BalancesLabels.DETAIL_KEYVALUES_SECURITIES,
                value: bd !== null ? bd.securitiesOwed.value: bdc.securitiesOwed.value,
                difference: bd !== null ? bd.securitiesOwed.difference : bdc.securitiesOwed.difference,
                percentChange: bd !== null ? bd.securitiesOwed.percentChange : bdc.securitiesOwed.percentChange,
                valuec: bdc !== null ? bdc.securitiesOwed.value : bd.securitiesOwed.value,
                differencec: bdc !== null ? bdc.securitiesOwed.difference : bd.securitiesOwed.difference,
                percentChangec: bdc !== null ? bdc.securitiesOwed.percentChange : bd.securitiesOwed.percentChange,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_SECURITIES],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_SECURITIES,
                displayAllValues:  type === 'custodian' ? true : false,
                legend: balancesService.updateDisclaimer({
                    'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_SECURITYOWED,
                    'show': true, 'className': 'securityOwed', 'showCounter': 0
                }),
                class: 'securitiesOwed'
            });
        }
        let cashMgmtLabel = BalancesLabels.DETAIL_KEYVALUES_CASHMANAGEMENT;
        if(deviceType === "mobile"){
            cashMgmtLabel = BalancesLabels.DETAIL_KEYVALUES_MOBILE_CASHMANAGEMENT
        }
        balanceDetail.push({
            name: cashMgmtLabel,
            value: bd !== null ? bd.cashManagementBalance.value: bdc.cashManagementBalance.value,
            difference: bd !== null ? bd.cashManagementBalance.difference : bdc.cashManagementBalance.difference,
            percentChange: bd !== null ? bd.cashManagementBalance.percentChange : bdc.cashManagementBalance.percentChange,
            valuec: bdc !== null ? bdc.cashManagementBalance.value : bd.cashManagementBalance.value,
            differencec: bdc !== null ? bdc.cashManagementBalance.difference : bd.cashManagementBalance.difference,
            percentChangec: bdc !== null ? bdc.cashManagementBalance.percentChange : bd.cashManagementBalance.percentChange,
            heirarchy: [cashMgmtLabel],
            children:
                [
                    {
                        name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_OPENINGBALANCE,
                        tooltip: BalancesLabels.DETAIL_TOOLTIPS_OPENBALANCES,
                        class: 'cashManagementBalance-openingBalance'
                    },
                    {
                        name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_TODAYACTIVITY,
                        tooltip: BalancesLabels.DETAIL_TOOLTIPS_TODAYACTIVITY,
                        class: 'cashManagementBalance-todaysActivity'
                    },
                    {
                        name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_MTDACCURUAL,
                        tooltip: BalancesLabels.DETAIL_TOOLTIPS_MDTACCURAL,
                        class: 'cashManagementBalance-monthToDateEarnings'
                    }
                ],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_CASHMANAGEMENT,
            displayAllValues: true,
            legend: balancesService.updateDisclaimer({
                'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CASHMGTINT,
                'show': true, 'className': 'cashMgtInt', 'showCounter': 0
            }),
            class: 'cashManagementBalance'
        });
        balanceDetail.push({
            name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_OPENINGBALANCE,
            value:  bd !== null ? bd.openingBalance.value : bdc.openingBalance.value,
            valuec:  bdc !== null && type === 'combined' ? bdc.openingBalance.value : null,
            heirarchy: [cashMgmtLabel, BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_OPENINGBALANCE],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_OPENBALANCES,
            class: 'cashManagementBalance-openingBalance'
        });
        balanceDetail.push({
            name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_TODAYACTIVITY,
            value:  bd !== null ? bd.todaysActivity.value: bdc.todaysActivity.value,
            valuec: bdc !== null && type === 'combined' ? bdc.todaysActivity.value : null,
            heirarchy: [cashMgmtLabel, BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_TODAYACTIVITY],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_TODAYACTIVITY,
            class: 'cashManagementBalance-todaysActivity'
        });
        balanceDetail.push({
            name: BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_MTDACCURUAL,
            value:  bd !== null ? bd.monthToDateEarnings.value : bdc.monthToDateEarnings.value,
            valuec: bdc !== null && type === 'combined' ? bdc.monthToDateEarnings.value : null,
            heirarchy: [cashMgmtLabel, BalancesLabels.DETAIL_CASHMANAGEMENTKEYS_MTDACCURUAL],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_MDTACCURAL,
            class: 'cashManagementBalance-monthToDateEarnings'
        });
        if (type != 'combined' && bdc !== null && bdc.cash !== undefined && bdc.cashAvailablePrincipal !== undefined && bdc.cashAvailableIncome !== undefined) {
            balanceDetail.push({
                name: BalancesLabels.DETAIL_KEYVALUES_CASH,
                value: bd !== null ? bd.cash.value : bdc.cash.value,
                difference: bd !== null ? bd.cash.difference : bdc.cash.difference,
                percentChange: bd !== null ? bd.cash.percentChange : bdc.cash.percentChange,
                valuec: bdc.cash.value,
                differencec: bdc.cash.difference,
                percentChangec: bdc.cash.percentChange,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_CASH],
                // Only applicable for Custodian Account
                children:
                    [
                        {
                            name: BalancesLabels.DETAIL_CASHKEYS_PRINCIPAL,
                            valuec: bdc.cashAvailablePrincipal === null ? 0: bdc.cashAvailablePrincipal,
                            tooltip: BalancesLabels.DETAIL_TOOLTIPS_PRINCIPAL,
                            class: 'cashAvailableCash-cashAvailablePrincipal'
                        },
                        {
                            name: BalancesLabels.DETAIL_CASHKEYS_INCOME,
                            valuec: bdc.cashAvailableIncome === null ? 0 : bdc.cashAvailableIncome,
                            tooltip: BalancesLabels.DETAIL_TOOLTIPS_INCOME,
                            class: 'cashAvailableCash-cashAvailableIncome'
                        }
                    ],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_CASH,
                class: 'cashAvailableCash',
                displayAllValues: true
            });
            let cashAvailablePrincipal = null ;
            let pershingPrinciple = null;
            if (type === 'combined') {
                if (bdc.cashAvailablePrincipal === null) {
                    cashAvailablePrincipal = 0;
                } else {
                    cashAvailablePrincipal = bdc.cashAvailablePrincipal;
                }
                pershingPrinciple = '-';
            }
            balanceDetail.push({
                name: BalancesLabels.DETAIL_CASHKEYS_PRINCIPAL,
                value: pershingPrinciple != null ? pershingPrinciple : ( bdc.cashAvailablePrincipal === null ? 0: bdc.cashAvailablePrincipal),
                valuec: cashAvailablePrincipal,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_CASH, BalancesLabels.DETAIL_CASHKEYS_PRINCIPAL],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_PRINCIPAL,
                class: 'cashAvailableCash-cashAvailablePrincipal'
            });
            let cashAvailableIncome = null;
            let pershingCashIncome = null;
            if (type === 'combined') {
            if (bdc.cashAvailableIncome === null) {
                cashAvailableIncome = 0;
            } else {
                cashAvailableIncome = bdc.cashAvailableIncome;
            }
            pershingCashIncome = '-';
        }
            balanceDetail.push({
                name: BalancesLabels.DETAIL_CASHKEYS_INCOME,
                value: pershingCashIncome !=null ? pershingCashIncome : (bdc.cashAvailableIncome === null ? 0 : bdc.cashAvailableIncome),
                valuec: cashAvailableIncome,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_CASH, BalancesLabels.DETAIL_CASHKEYS_INCOME],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_INCOME,
                class: 'cashAvailableCash-cashAvailableIncome'
            });
        } else {
            balanceDetail.push({
                name: BalancesLabels.DETAIL_KEYVALUES_CASH,
                value: bd !== null ? bd.cash.value : bdc.cash.value,
                difference: bd !== null ? bd.cash.difference : bdc.cash.difference,
                percentChange: bd !== null ? bd.cash.percentChange : bdc.cash.percentChange,
                valuec: bdc !== null ? bdc.cash.value : bd.cash.value,
                differencec: bdc !== null ? bdc.cash.difference : bd.cash.difference,
                percentChangec: bdc !== null ? bdc.cash.percentChange : bd.cash.percentChange,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_CASH],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_CASH,
                displayAllValues: true,
                class: 'cash'
            });
        }
        if ((bd !== null && bd.annuities.value && bd.annuities.value !== 0) || (bdc !== null && bdc.annuities.value && bdc.annuities.value !== 0)) {
            balanceDetail.push({
                name: BalancesLabels.DETAIL_KEYVALUES_TOTALANNUITY,
                value: bd !== null ? bd.annuities.value : bdc.annuities.value,
                difference: bd !== null ? bd.annuities.difference : bdc.annuities.difference,
                percentChange: bd !== null ? bd.annuities.percentChange : bdc.annuities.percentChange,
                valuec: bdc !== null ? bdc.annuities.value : bd.annuities.value,
                differencec: bdc !== null ? bdc.annuities.difference : bd.annuities.difference,
                percentChangec: bdc !== null ? bdc.annuities.percentChange : bd.annuities.percentChange,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_TOTALANNUITY],
                children:
                    [
                        {
                            name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALVARANNUITY,
                            class: 'annuities-annuityVariableValAmt'
                        },
                        {
                            name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALFIXEDANNUITY,
                            class: 'annuities-annuityVariableValAmt'
                        },
                        {
                            name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALPENDANNUITY,
                            class: 'annuities-annuityVariableValAmt'
                        }
                    ],
                tooltip: BalancesLabels.DETAIL_TOOLTIPS_TOTALANNUITY,
                displayAllValues: true,
                class: 'annuities'
            });
            balanceDetail.push({
                name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALVARANNUITY,
                value: bd !== null ? bd.annuityVariableValAmt : bdc.annuityVariableValAmt,
                valuec: bdc !== null && type === 'combined' ? bdc.annuityVariableValAmt : null,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_TOTALANNUITY, BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALVARANNUITY],
                class: 'annuities-annuityVariableValAmt'
            });
            balanceDetail.push({
                name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALFIXEDANNUITY,
                value: bd !== null ? bd.annuityFixedValAmt : bdc.annuityFixedValAmt,
                valuec: bdc !== null && type === 'combined' ? bdc.annuityFixedValAmt : null,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_TOTALANNUITY, BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALFIXEDANNUITY],
                class: 'annuities-annuityVariableValAmt'
            });
            balanceDetail.push({
                name: BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALPENDANNUITY,
                value: bd !== null ? bd.annuityPendingValAmt : bdc.annuityPendingValAmt,
                valuec: bdc !== null && type === 'combined' ? bdc.annuityPendingValAmt : null,
                heirarchy: [BalancesLabels.DETAIL_KEYVALUES_TOTALANNUITY, BalancesLabels.DETAIL_TOTALANNUITYKEYS_TOTALPENDANNUITY],
                class: 'annuities-annuityVariableValAmt'
            });
        }
        balanceDetail.push({
            name: BalancesLabels.DETAIL_KEYVALUES_TOTALACCOUNT,
            value: bs !== null ? bs.totalWorth.value : bsc.totalWorth.value,
            difference: bs !== null ? bs.totalWorth.difference : bsc.totalWorth.difference,
            percentChange: bs !== null ? bs.totalWorth.percentChange : bsc.totalWorth.percentChange,
            valuec: bsc !== null ? bsc.totalWorth.value : bs.totalWorth.value,
            differencec: bsc !== null ? bsc.totalWorth.difference : bs.totalWorth.difference,
            percentChangec: bsc !== null ? bsc.totalWorth.percentChange : bs.totalWorth.percentChange,
            heirarchy: [BalancesLabels.DETAIL_KEYVALUES_TOTALACCOUNT],
            tooltip: BalancesLabels.DETAIL_TOOLTIPS_TOTALNETWORTHANNUITY,
            displayAllValues: true,
            class: 'totalWorth'
        });
        return(balanceDetail);
    }
}